import Presolicitud from "@/models/Presolicitud";
import RegistroDocumentosPresolicitud from "@/models/RegistroDocumentosPresolicitud";
import DocumentoPresolicitud from './DocumentoPresolicitud';

export default class RegistroPresolicitud {
    constructor(
        public presolicitud: Presolicitud = new Presolicitud(),
        public registroDocumentosPresolicitud: RegistroDocumentosPresolicitud = new RegistroDocumentosPresolicitud(),
        public archivosEliminados: Array<DocumentoPresolicitud> = [],
        /** Indica al servicio de siembra que tipo de documento es cada archivo subido */
        public tiposDocumento: Array<string> = []
    ) {}
}